// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
// ICONS
import { IoClose } from 'react-icons/io5'
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import ContentHeader from './ContentHeader';
import Button from './Button';
// HELPERS

const ModalBlock = (props) => {
    const dialogClassName = `aes-modal-dialog ${props.dialogClassName ? props.dialogClassName : ""}`.trim();
    const contentClassName = `aes-modal-content ${props.contentClassName ? props.contentClassName : ""}`.trim();

    return (
        <>
            <Modal
                {...props}
                show={props.show ? props.show : false}
                onHide={props.onHide ? props.onHide : () => { }}
                dialogClassName={dialogClassName}
                contentClassName={contentClassName}
                scrollable={props.scrollable !== false}
            >
                {
                    props.closeAction &&
                    <CustomBlock className="close-action-container">
                        <button
                            className="close-action"
                            onClick={props.closeActionOnClick ? props.closeActionOnClick : props.onHide}
                        >
                            <IoClose size={30} className={`${props.closeIconColor ? props.closeIconColor : "primary--clr"}`} />
                        </button>
                    </CustomBlock>
                }

                <CustomBlock className="aes-modal-body content-container--card-style">
                    <ContentHeader
                        {...props}
                        title={props.contentHeader}
                        subtitle={props.subtitle}
                        primaryButtonText={props.primaryButtonText}
                        headerSize="md"
                    />
                    {
                        props.contentDescription &&
                        <CustomBlock className={`${props.centeredTitle ? "text-center" : ""}`}>
                            <div className="content-description" dangerouslySetInnerHTML={{ __html: props.contentDescription }} />
                        </CustomBlock>
                    }
                    {props.children}

                    {
                        props.primaryModalActionOnClick &&
                        <CustomBlock className="content-container--actions pr-0">
                            <Button
                                type={props.secondaryModalActionType}
                                text={props.secondaryModalActionText ? props.secondaryModalActionText : "Cancel"}
                                className={props.secondaryModalActionColor ? props.secondaryModalActionColor : "grey--bg"}
                                onClick={props.secondaryModalActionOnClick ? props.secondaryModalActionOnClick : props.onHide}
                                size="xs"
                            />

                            <Button
                                type={props.primaryModalActionType}
                                text={props.primaryModalActionText ? props.primaryModalActionText : "Delete"}
                                className={props.primaryModalActionColor ? props.primaryModalActionColor : "danger--bg"}
                                onClick={props.primaryModalActionOnClick ? props.primaryModalActionOnClick : {}}
                                size="xs"
                            />
                        </CustomBlock>
                    }
                </CustomBlock>
            </Modal>
        </>
    );
}

export default ModalBlock;
